import React from "react";
import { ArrowUp, Plus } from "lucide-react";
import { MiniCharacter } from "./character-stage";

export default function ProjectUI({ project }) {
  let content;

  if (project.ui === "prompt") {
    return (
      <div className="ue-prompt" aria-hidden="true">
        <div className="ue-prompt-field">
          <span className="ue-prompt-placeholder">
            Ask a question about your research.
          </span>
          <span className="ue-prompt-actions">
            <span className="ue-prompt-plus">
              <Plus aria-hidden="true" />
            </span>
            <span className="ue-prompt-send">
              <ArrowUp aria-hidden="true" />
            </span>
          </span>
        </div>
        <div className="ue-prompt-links">
          <span>Start an AI interview</span>
          <span>Analyze a transcript</span>
          <span>Get paid to test</span>
        </div>
      </div>
    );
  }

  if (project.ui === "domains") {
    return (
      <div className="ad-terminal" aria-hidden="true">
        <span className="ad-comment"># the agent built a site</span>
        <span className="ad-cmd">
          <b>$</b> agentdomains claim myapp
        </span>
        <span className="ad-ok">✓ myapp.makes.fyi is live</span>
      </div>
    );
  }

  if (project.ui === "chat") {
    content = (
      <div className="ui-chat">
        <span><b>Ada</b> Pricing page is ready for review.</span>
        <span><b>Judge</b> All checks passed. Marked done.</span>
      </div>
    );
  } else if (project.ui === "research") {
    content = (
      <div className="ui-insight">
        <small>Insight 04 · 8 citations</small>
        <strong>Users need a clearer first task.</strong>
        <span>Read source lines →</span>
      </div>
    );
  } else if (project.ui === "terminal") {
    content = (
      <div className="ui-terminal">
        <span><b>ob1 ›</b> fix the failing tests</span>
        <span>3 files to edit</span>
        <strong>✓ 42 checks passed</strong>
      </div>
    );
  } else if (project.ui === "odds") {
    content = (
      <div className="ui-odds">
        <span>Prediction confidence</span>
        <strong>Man City <b>72%</b></strong>
        <i><b /></i>
        <small>Current odds: 2.10</small>
      </div>
    );
  } else {
    content = (
      <div className="ui-call">
        <strong>Pitch review board</strong>
        <div>
          {['M', 'L', 'A', 'S', 'I', 'M'].map((initial, index) => (
            <span key={`${initial}-${index}`}>{initial}</span>
          ))}
        </div>
        <small>Maya has the microphone.</small>
      </div>
    );
  }

  return (
    <div className={`project-ui project-ui--${project.ui}`} aria-hidden="true">
      <div className="project-ui-content">{content}</div>
      <MiniCharacter {...project.character} />
    </div>
  );
}

